import React from 'react'
import { Grid } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { FadeLoader } from 'react-spinners'

/** Images **/
import { images } from '../lib/Constants'

const useStyles = makeStyles()((theme) => {
  return {
    fadeloader: { transform: 'scale(0.85)' },
    container: {
      minHeight: '100vh',
      overflow: 'hidden'
    }
  }
})

export const LoadingSplash = () => {
  const { classes } = useStyles()
  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      spacing={0}
      className={classes.container}
    >
      <Grid item xs={12} textAlign="center" alignSelf="center">
        <img src={images.logo} width={230} alt="Mywork Enterprise" />
      </Grid>
      <Grid item xs={12} p={2}>
        <div className={classes.fadeloader}>
          <FadeLoader loading={true} height={12} width={4}/>
        </div>
      </Grid>
    </Grid>
  )
}
